/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import MembershipRepository from '../../repositories/Admin/FastCash/MembershipRepository';
import { createRestSlice } from '../../utils/RestSlice';

const membershipRestSlice = createRestSlice({
  resource: 'membership',
  repository: MembershipRepository,
  slices: ['createMembership', 'updateMembership'],
});

const initialState = {
  ...membershipRestSlice.initialState,
};

const membershipSlice = createSlice({
  name: 'membership',
  initialState,
  reducers: {
    ...membershipRestSlice.reducers,
  },
});

export default membershipSlice.reducer;

export const membershipRestHooks = membershipRestSlice.hooks(membershipSlice, [
  'admin',
  'MembershipSlice',
]);
